import Vue, { VueConstructor } from 'vue';

declare module 'vue/types/vue' {
  interface Vue {
    $metaData: Record<string, any>;
    $setMeta: (meta: Record<string, any>) => void;
  }
}

const metaPlugin = {
  install(Vue: VueConstructor) {
    Vue.prototype.$metaData = {};

    Vue.prototype.$setMeta = function (meta: Record<string, any>) {
      this.$metaData = meta;
    };
  },
};

export default metaPlugin;